import { studentSignUp } from '../../../modules/student/api';
import { CreateStudentPayload, Student } from '../../../modules/student/types';

export const studentSignupUseCase = (payload: CreateStudentPayload): Promise<Student> => {
  return studentSignUp(payload);
};
